// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "27bfe3a076bfc3c62a01" + ".chunk.js";
};